import { render, staticRenderFns } from "./YA_GrammarFixContent1.vue?vue&type=template&id=41643f15&scoped=true"
import script from "./YA_GrammarFixContent1.vue?vue&type=script&lang=js"
export * from "./YA_GrammarFixContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41643f15",
  null
  
)

export default component.exports